import { SiteHeader, SiteFooter } from "./SiteLayout";
import { useSiteContent, usePageMeta } from "./siteContent";
import SiteSections from "./SiteSections";

export default function SiteContact() {
  const site = useSiteContent();
  usePageMeta("Contact Us | Wales Event Medical Services",
    "Get in touch to discuss medical cover for your event — free, no-obligation quotes for events of any size across Wales and the UK.", "", "contact");
  return (
    <div className="site-font bg-[#0B0F14]" data-testid="site-contact">
      <SiteHeader />
      <SiteSections sections={site.page_sections.contact} services={site.services_catalog} contact={site.contact_info} />
      <SiteFooter />
    </div>
  );
}
